export default __webpack_public_path__ + "static/logo-1fd5b23c765dc16e93b2355dcfe5d250.png";